module.exports = __webpack_public_path__ + "static/giacomo-imperato-a36f18b4938416d7ce4a3844839330ea.jpg";